"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _generalStore = require("general-store");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _InitialNoteContentDependency = _interopRequireDefault(require("customer-data-communicator/data/interactions/note/dependencies/InitialNoteContentDependency"));

var _InteractionWithInitialContent = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithInitialContent"));

var _default = function _default(InteractionComponent) {
  var Component = (0, _InteractionWithInitialContent.default)(InteractionComponent);
  return (0, _generalStore.connect)(_InitialNoteContentDependency.default, _dispatcher.default)(Component);
};

exports.default = _default;
module.exports = exports.default;